import { Icons } from '@/app/components/ui/Icons'
import { Currency } from '@/app/types'
import classNames from 'classnames'
import { FC } from 'react'
import { CircleFlag } from 'react-circle-flags'
import { CustomScroll } from 'react-custom-scroll'

interface CurrencySelectorMobileProps {
	isOpen: boolean
	selectedCurrency: Currency
	currencies: Currency[]
	onCurrencyChange: (currency: Currency) => void
}

const CurrencySelectorMobile: FC<CurrencySelectorMobileProps> = ({
	isOpen,
	selectedCurrency,
	currencies,
	onCurrencyChange,
}) => {
	return (
		<div
			className="grow flex flex-col items-start"
			id="currency-selector-mobile"
		>
			<div
				className={classNames(
					'max-h-0 transition-all h-full opacity-0 w-full',
					{
						'max-h-[50vh] opacity-100 py-2 overflow-auto': isOpen,
						'overflow-hidden': !isOpen,
					}
				)}
			>
				<CustomScroll allowOuterScroll={false} heightRelativeToParent="100%">
					{currencies.map((currency: Currency, index: number) => (
						<div
							onClick={() => onCurrencyChange(currency)}
							key={`${currency.abbreviation}-${index}`}
							className={classNames(
								'flex items-center p-3 cursor-pointer hover:bg-gray-100 rounded-md h-14',
								{
									'bg-gray-50':
										currency.abbreviation === selectedCurrency.abbreviation,
								}
							)}
							id={`currency_selected_${currency.abbreviation}`}
						>
							<CircleFlag
								countryCode={currency.flag.toLowerCase()}
								className="w-4 h-4 mr-2"
							/>
							<span className="text-sm mr-1 font-semibold">
								{currency.label}
							</span>
							<span className="uppercase text-sm text-text-600">
								{currency.abbreviation}
							</span>
							<Icons.iconCheck
								className={`${
									currency.abbreviation === selectedCurrency.abbreviation
										? 'block'
										: 'hidden'
								} ms-auto`}
							/>
						</div>
					))}
				</CustomScroll>
			</div>
		</div>
	)
}

export default CurrencySelectorMobile
